import { OrgModal } from '@/components/OrgModal'
import { useAuth } from './AuthProvider'
import { ContactModalProvider } from './ContactModalProvider'
import { ContactModal } from '@/components/ContactModal'

// * For any globally available UI such as modals, anything related only to halls belongs in MeetingRoom.tsx
const UIWrapper = ({ children }) => {
  const { currentOrg } = useAuth()
  return (
    <ContactModalProvider>
      {currentOrg && <OrgModal />}
      <ContactModal />
      {children}
    </ContactModalProvider>
  )
}

export default UIWrapper
